import moment from 'moment'

const formatEventDateRange = ({ start, end }) => {
  const startDay = moment(start)
  const endDay = moment(end)
  const isRange = endDay.diff(startDay, 'days') > 0
  const multipleMonths = endDay.month() !== startDay.month()
  const startFormat = multipleMonths ? 'Do MMMM' : 'Do'
  return isRange
    ? `${moment(start).format(startFormat)} - ${moment(end).format('Do MMMM')}`
    : moment(start).format('Do MMMM')
}
export default formatEventDateRange
